import {Component} from "inferno";
import {AppState} from "../../services/configuration";
import {Button, Nav} from "inferno-bootstrap";
import VideoOff from "inferno-feather/dist/icons/video-off";
import VolumeOff from "inferno-feather/dist/icons/volume-x";
import VolumeOn from "inferno-feather/dist/icons/volume-2";
import Maximize from "inferno-feather/dist/icons/maximize-2";
import {Tooltip} from "../../components/Tooltip";
import {App} from "../../App";
import {Level} from "../../utils/types";
import {Channel, ContactLeg, Event, EventBusInstance, TrackType} from "@sap/cpaas-commlib-lib";
import {Bundle} from "../../services/translationProvider";

export type Props = {};
export type State = { active: boolean, videoActive: boolean, audioActive: boolean, loading: boolean };

export class Video extends Component<Props, State> {

	remoteVideo: any;
	localVideo: any;

	state: State = {
		loading: true,
		active: false,
		videoActive: false,
		audioActive: false,
	};

	componentDidMount() {
		EventBusInstance.subscribe(Event.ContactLeg(Channel.all).offer, this.onMediaOffer, this);
	}

	startVideo = () => {
		if (!this.state.active) {
			this.onToggleVideo();
		}
	};

	onToggleVideo = async () => {
		if (this.state.videoActive) {
			try {
				AppState.activeLeg.stopVideo();
			} catch (e) {
				// hide video anyway
			}
			this.setState({active: false, videoActive: false});
		} else {
			this.setState({active: true, loading: true});
			try {
				await AppState.activeLeg.startVideo();
			} catch (e) {
				App.ShowMsg("VCC_XMSG_VIDEO_FAIL", Level.Danger);
				this.setState({active: false});
				return;
			}
			this.setState({active: true, loading: true}, this.setVideo);
		}
	};

	onMediaOffer = async (channel: string, event: string, leg: ContactLeg) => {
		/*try {
			await App.ShowQuery("VCC_XBUT_VIDEO_START_NOTIFICATION", Level.Info, "VCC_XBUT_VIDEO_BUTTON_ACCEPT", "VCC_XBUT_VIDEO_BUTTON_REJECT");
		} catch (e) {
			return;
		}*/
		this.setState({active: true, loading: true});
		try {
			await AppState.activeLeg.acceptVideo();
		} catch (e) {
			App.ShowMsg("VCC_XMSG_VIDEO_FAIL", Level.Danger);
			this.setState({active: false});
			return;
		}
		this.setState({active: true, loading: true}, this.setVideo);
	};

	setVideo = () => {
		this.remoteVideo.srcObject = AppState.activeLeg.getRemoteStream();
		this.localVideo.srcObject = AppState.activeLeg.getLocalStream();
		this.remoteVideo.addEventListener("play", this.onPlay);
		AppState.activeLeg.getTrack(TrackType.remote_video).addEventListener("ended", (e: any) => this.setState({active: false, videoActive: false}));
		this.setState({videoActive: true});
	};

	onPlay = () => {
		this.setState({loading: false});
		this.remoteVideo.removeEventListener("play", this.onPlay);
	};

	onToggleAudio = () => {
		const track = AppState.activeLeg.getTrack(TrackType.local_audio);
		if (track) {
			track.enabled = !track.enabled;
			this.setState({audioActive: !track.enabled});
		} else {
			App.ShowMsg("VCC_XMSG_VIDEO_MUTE_FAIL", Level.Danger);
		}
	};

	onFullScreen = () => {
		if (this.remoteVideo !== null) {
			const video: any = this.remoteVideo;
			if (video.requestFullscreen) {
				video.requestFullscreen();
			} else if (video.mozRequestFullScreen) {
				video.mozRequestFullScreen();
			} else if (video.webkitRequestFullScreen) {
				video.webkitRequestFullScreen();
			} else if (video.msRequestFullscreen) {
				video.msRequestFullscreen();
			}
		}
	};

	stopVideo = () => {
		try {
			AppState.activeLeg.stopVideo();
		} catch (e) {
			// hide video anyway
		}
		this.setState({active: false, videoActive: false});
	};

	render() {
		if (!this.state.active) {
			return <span/>;
		}
		return (
			<div>
				<div style={{"max-height": "40%"}} class="w-100 p-0 position-relative video">
					{this.state.loading &&
					<div className="spinner-animation border-warning border-top border-left rounded-circle position-absolute"
						style={{"margin-left": "-100px", "margin-top": "-100px", top: "50%", left: "50%", width: "200px", height: "200px"}}/>}
					<video ref={(node: HTMLElement) => this.remoteVideo = node} autoPlay class="bg-dark w-100 p-0"/>
					<video ref={(node: HTMLElement) => this.localVideo = node} muted autoPlay style={{height: "90px", bottom: 0, left: 0}} class="shadow bg-transparent m-1 position-absolute"/>
				</div>
				<Nav className="justify-content-between align-items-center bg-light d-flex">
					<div className="text-secondary">{(this.state.loading && Bundle.t("VCC_XMSG_MSG_LOADING"))}</div>
					<div>
						<Button disabled={!this.state.videoActive} onClick={this.onFullScreen} color="light">
							<Maximize id="max-btn" className={"text-primary"}/>
							<Tooltip target="max-btn" content="VCC_XTOL_CHAT_FULLSCREEN_TOOLTIP" placement="top"/>
						</Button>
						<Button disabled={!this.state.videoActive} onClick={this.onToggleAudio} color="light">
							<VolumeOn id="soff-btn" className={"text-primary" + (!this.state.audioActive ? "" : " d-none")}/>
							<Tooltip target="soff-btn" content="VCC_XTOL_CHAT_AUDIO_D_TOOLTIP" placement="top"/>
							<VolumeOff id="son-btn" className={"text-primary" + (this.state.audioActive ? "" : " d-none")}/>
							<Tooltip target="son-btn" content="VCC_XTOL_CHAT_AUDIO_E_TOOLTIP" placement="top"/>
						</Button>
						<Button onClick={this.stopVideo} color="light">
							<VideoOff id="voff-btn" className="text-danger"/>
							<Tooltip target="voff-btn" content="VCC_XTOL_CHAT_VIDEO_D_TOOLTIP" placement="top"/>
							{/*<VideoOn id="von-btn" className={"text-primary" + (!this.state.videoActive ? "" : " d-none")}/>*/}
							{/*<Tooltip target="von-btn" content="VCC_XTOL_CHAT_VIDEO_E_TOOLTIP" placement="top"/>*/}
						</Button>
					</div>
				</Nav>
			</div>
		);
	}
}
